import request from '@/utils/request'

// 获取证书信息
export function getCertificateQuery (data) {
  return request({
    url: '/pub/certificate/query',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/search.js